import { ErrorResponseSchema } from '@cookspace-shared-contracts/core';

/**
 * Generic-сообщения по бизнес-кодам слияния городов (FR-21, контракт
 * AdminCities.MergeCity + admin-backend): показываем понятный человеку
 * текст, не раскрывая технических деталей.
 *
 * Коды (из JSDoc контракта POST /cities/:id/merge):
 *  - CITY_MERGE_SELF (400) — источник == цель;
 *  - CITY_NOT_FOUND (404) — источник или цель не найдены;
 *  - CITY_ALREADY_MERGED (409) — источник уже дубль / цель — дубль.
 * Незнакомый код падает в fallback.
 */
const ERROR_MESSAGES: Record<string, string> = {
    CITY_MERGE_SELF: 'Нельзя объединить город сам с собой — выберите другой целевой город',
    CITY_NOT_FOUND: 'Город не найден — обновите страницу и попробуйте снова',
    CITY_ALREADY_MERGED:
        'Один из городов уже объединён с другим — обновите страницу и попробуйте снова'
};

/**
 * Достаёт `error.data.error.code` из ошибки RTK Query (`FetchBaseQueryError`
 * формы `{ status, data }`) и возвращает generic-сообщение по коду.
 * Любая незнакомая/непарсибельная форма → fallback.
 */
export function getCityMergeErrorMessage(error: unknown, fallback: string): string {
    if (typeof error !== 'object' || error === null || !('data' in error)) {
        return fallback;
    }
    const parsed = ErrorResponseSchema.safeParse((error as { data?: unknown }).data);
    if (!parsed.success) {
        return fallback;
    }
    return ERROR_MESSAGES[parsed.data.error.code] ?? fallback;
}
